import React, {ReactChild} from 'react';

import {Icon, IconClose, IconName} from '../../Icon';
import {
  LABEL_COLORS,
  LABEL_MODES,
  LABEL_VARIANTS,
  LabelColor,
  LabelMode,
  LabelVariant,
} from './Label.constants';
import {StyledLabel} from './Label.styles';

export type LabelProps = {
  /** Label Variant */
  variant?: LabelVariant;
  /** Label Color */
  color?: LabelColor;
  /** Label Mode */
  mode?: LabelMode;
  /** What renders inside the label */
  children?: ReactChild;
  /** An Icon to render at the beginning of the Label */
  icon?: IconName;
  /** Function to run when closing a Tag Label */
  onClose?: () => void;
  /** Whether or not to show IconClose at the end of the TagLabel*/
  showCloseIcon?: boolean;
};

export const Label = ({
  children,
  icon,
  variant = LABEL_VARIANTS.PILL,
  color = LABEL_COLORS.GRAY,
  mode = LABEL_MODES.NIGHT,
  onClose,
  showCloseIcon = true,
  ...props
}: LabelProps) => {
  return (
    <StyledLabel
      variant={variant}
      mode={mode}
      color={color}
      showCloseIcon={showCloseIcon}
      {...props}>
      {icon ? <Icon name={icon} width="16px" height="16px" /> : null}
      {children}
      {variant === LABEL_VARIANTS.TAG && showCloseIcon && (
        <IconClose onClick={onClose} width="16px" height="16px" />
      )}
    </StyledLabel>
  );
};

// MODES
export const LightLabel = (props: LabelProps) => (
  <Label mode={LABEL_MODES.LIGHT} {...props} />
);
export const NightLabel = (props: LabelProps) => (
  <Label mode={LABEL_MODES.NIGHT} {...props} />
);

// VARIANTS
export const PillLabel = (props: LabelProps) => (
  <Label variant={LABEL_VARIANTS.PILL} {...props} />
);
export const TagLabel = (props: LabelProps) => (
  <Label variant={LABEL_VARIANTS.TAG} {...props} />
);

// COLORS
export const GreenLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.GREEN} {...props} />
);
export const TealLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.TEAL} {...props} />
);
export const SiennaLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.SIENNA} {...props} />
);
export const GoldLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.GOLD} {...props} />
);
export const RedLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.RED} {...props} />
);
export const GrayLabel = (props: LabelProps) => (
  <Label color={LABEL_COLORS.GRAY} {...props} />
);
